import { useWizard } from "react-use-wizard";
import dealServiceSteps from "./dealServiceSteps";
import { IFillDataWizardDealService } from "..";
import BaseStep from "../../../../../shared/wizard/steps/baseStep";
import Button from "../../../../../ui/button";
import AuthModal from "../../../../auth/components/modals/authModal";
import useDealRequest from "../../../../../../api/hooks/use-deal-request";
import { getAccessToken } from "../../../../../../lib/services/localStorage.service";
import { toast } from "react-toastify";
import { EDealRequestType, EMarketTypes } from "../../../../../../interfaces";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../../../../shared/constants";
import useOpenModal from "../../../../../ui/modal/hooks/useOpenModal";

interface IStepDealService_6 {
  data: IFillDataWizardDealService;
}

const StepDealService_6 = ({ data }: IStepDealService_6) => {
  const { goToStep } = useWizard();
  const navigate = useNavigate();

  const handlePrevStep = () => {
    goToStep(dealServiceSteps.step_5);
  };

  const {
    data: dataDealRequest,
    error,
    isMutating,
    trigger,
  } = useDealRequest();

  const {
    offsetY: offsetYAuth,
    open: openAuth,
    handleChangeModal: handleChangeModalAuth,
  } = useOpenModal();

  const handleSendData = async () => {
    if (getAccessToken()) {
      try {
        await trigger({
          type: EDealRequestType.DealService,
          data,
          marketType: EMarketTypes.SECONDARY,
        });
        toast.success("Заявка на сервис создана");
        navigate(`/${PATHS.myDeal}`);
      } catch (error: any) {
        if (error?.message === "Unauthorized") {
          handleChangeModalAuth(true);
        }
        toast.error("Ошибка не удалось отправить заявку");
      }
    } else {
      handleChangeModalAuth(true);
    }
  };

  return (
    <div>
      <BaseStep prevStep={handlePrevStep} text="Отправка заявки:">
        <div>
          <Button label="Отправить заявку на обмен" onClick={handleSendData} />
          <AuthModal
            opened={openAuth}
            onClose={() => handleChangeModalAuth(false)}
            offsetY={offsetYAuth}
          />
        </div>
      </BaseStep>
    </div>
  );
};

export default StepDealService_6;
